import { useSelector } from 'react-redux'
import classNames from 'classnames'
import Button from 'components/forms/Button'
import * as analytics from 'lib/analytics'
import Tooltip from './Tooltip'

import styles from './styles/PluginButton.css'

const SUPPORTED_BROWSERS = [
  'chrome',
  'firefox',
  'safari'
]

const PluginButton = ({ className }) => {
  const browser = useSelector(({ ui }) => ui.browser)
  const browserName = SUPPORTED_BROWSERS.includes(browser?.name) ? browser?.name : 'chrome'
  const links = {
    chrome: CONFIG.plugin.chromeLink,
    firefox: CONFIG.plugin.firefoxLink,
    safari: CONFIG.plugin.safariLink
  }

  return (
    <Tooltip
      className={styles.tooltip}
      content={(
        <>
          See how research has been cited anywhere you are reading literature online.
          <br />
          <br />
        </>
      )}
    >
      <Button
        className={classNames(styles.button, className)} color='white' pill tabIndex='0' onClick={() => {
          analytics.event({
            category: 'Plugin',
            action: 'clicked-nav-button'
          })

          window.open(links[browserName])
        }}
      >
        <span className={styles.text}>Install </span>
        <b className={styles.browserText}>extension! </b>
        <img
          alt={`${browserName}`}
          className={styles.browserIcon}
          src={`${CONFIG.assetsBaseURL}/images/icons/${browserName}.svg`}
          width='20px'
          height='20px'
        />
      </Button>
    </Tooltip>
  )
}

export default PluginButton
